Vue.component('about-video', {
    data() {
        return {
            opened: false,
            video: 'https://www.youtube.com/embed/cb32vac1dWM'
        }
    },
    methods: {
        open() {
            this.opened = true
            this.$refs.video.src += "?autoplay=1"
        },
        close() {
            this.opened = false
            this.$refs.video.src = this.video
        }
    }
})